if (!window.Eurus.loadedScript.has('variant-select-card.js')) {
  window.Eurus.loadedScript.add('variant-select-card.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xVariantSelectCard', (
        element,
        sectionId,
        productId,
        productUrl,
        customizableChooseOption,
        chooseOption,
        productBundle,
        pageParam,
        chooseOptionLabel,
        addToCartLabel,
      ) => ({
        loadingEls: '',
        currentVariant: {},
        cachedResults: [],
        init() {
          document.addEventListener(`eurus:product-card:clear:${productId}`, () => { 
            this._reloadCardProduct();
          });
          // Initialize alt tag filtering on load if variants are pre-selected
          setTimeout(() => {
            const hasSelectedVariants = element.querySelectorAll('input:checked').length > 0;
            if (hasSelectedVariants) {
              this._applyMetalImages();
              this._filterCardImagesByAltTag();
            }
          }, 100);
        },
        _dispatchUpdateVariant(html="") {
          window.requestAnimationFrame(() => {
            setTimeout(() => { this.loadingEls = ''; }, 100);
          })
          document.dispatchEvent(new CustomEvent(`eurus:product-card-variant-select:updated:${sectionId}`, {
            detail: {
              currentVariant: this.currentVariant,
              html: html
            }
          }));
        },
        
        _renderCardProductFormInput(formSrc, formDes) {
          const desInput = formDes.querySelectorAll('input');
          desInput?.forEach((input) => {
            if (input.name !== 'section-id' && input.name) {
              const src = formSrc.querySelector(`input[name=${CSS.escape(input.name)}]`);
              if (src) {
                input.value = src.value;
                input.checked = src.checked;
                input.disabled = src.disabled;
              }
            }
          });
        },
        _renderCardProductFormButton(formSrc, formDes) {
          const srcButton = formSrc.querySelector(`button`);
          if (srcButton) {
            const srcButtonText = srcButton.querySelector('.button-text');
            
            const desButton = formDes.querySelectorAll('button[type="submit"]');
            desButton.forEach((button) => {
              button.disabled = srcButton.disabled;
              button.ariaLabel = srcButton.ariaLabel;

              const desButtonText = button.querySelector('.button-text');
              if (srcButtonText.textContent.trim() == chooseOptionLabel) {
                srcButtonText.textContent = addToCartLabel;
              }
              if (desButtonText && srcButtonText) {
                desButtonText.innerHTML = srcButtonText.innerHTML;
              }
            });
          }
        },
        _renderCardProductForm(html) {
          let target = chooseOption ? '.choose-options' : '.card-product'

          const formSrc = html.querySelector('form[id*="product-form-"]');
          const formDesAll = element.closest(target)?.querySelectorAll('form[id*="product-form-"]');
          if (formSrc && formDesAll) { 
            formDesAll.forEach(formDes => {
              this._renderCardProductFormInput(formSrc, formDes);
              this._renderCardProductFormButton(formSrc, formDes);
            });
          }
        },
        _renderCardProductCurrentVariant(optionSrc, optionDes) {
          const currentVariantSrc = optionSrc.querySelector('.current-variant');
          const currentVariantDes = optionDes.querySelector('.current-variant');

          if (currentVariantSrc && currentVariantDes) {
            currentVariantDes.innerHTML = currentVariantSrc.innerHTML;
          }
        },
        _renderCardProductInputs(optionSrc, optionDes) {
          const inputsSrc = optionSrc.querySelectorAll('input');
          const inputsDes = optionDes.querySelectorAll('input');

          inputsDes?.forEach(des => {
            const src = Array.from(inputsSrc).find((inputSrc) => inputSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              if (src.classList.contains('disabled')) {
                des.classList.add('disabled');
              } else {
                des.classList.remove('disabled');
              }
              des.checked = src.checked;
              des.dataset.available = src.dataset.available;
            }
          });
        },
        _renderCardProductOptions(optionSrc, optionDes) {
          const optionsSrc = optionSrc.querySelectorAll('option');
          const optionsDes = optionDes.querySelectorAll('option');

          optionsDes?.forEach(des => {
            const src = Array.from(optionsSrc).find((optionSrc) => optionSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              des.selected = src.selected;
              des.innerHTML = src.innerHTML;
            }
          });
        },
        _renderCardProductInputLabels(optionSrc, optionDes) {
          const labelsSrc = optionSrc.querySelectorAll('label');
          const labelsDes = optionDes.querySelectorAll('label');

          labelsDes?.forEach(des => {
            const src = Array.from(labelsSrc).find((labelSrc) => labelSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src) {
              if (des.style.getPropertyValue('--bg-image').trim() !== '') {
                des.style.setProperty('--bg-image', src.style.getPropertyValue('--bg-image'));
              }
              if (des.style.getPropertyValue('--ratio-image').trim() !== '') {
                des.style.setProperty('--ratio-image', src.style.getPropertyValue('--ratio-image'));
              }
            }
          });
        },
        _renderCardProductValueVariant(optionSrc, optionDes) {
          const scriptsSrc = optionSrc.querySelectorAll('script[type="application/json"][data-option-value-id]');
          const scriptsDes = optionDes.querySelectorAll('script[type="application/json"][data-option-value-id]');

          scriptsDes?.forEach(des => {
            const src = Array.from(scriptsSrc).find((scriptSrc) => scriptSrc.dataset.optionValueId === des.dataset.optionValueId);
            if (src && des) {
              des.textContent = src.textContent;
            }
          })
        },
        _renderCardProductOption(html) {
          const optionSrc = html.querySelector('.x-variants-data-js');
          const optionDes = element.closest('.x-variants-data-js');

          if (optionSrc && optionDes) {
            this._renderCardProductCurrentVariant(optionSrc, optionDes);
            this._renderCardProductInputs(optionSrc, optionDes);
            this._renderCardProductOptions(optionSrc, optionDes);
            this._renderCardProductInputLabels(optionSrc, optionDes);
            this._renderCardProductValueVariant(optionSrc, optionDes);
          }
        },
        _renderCardProductPrice(html) {
          let target = chooseOption ? '.choose-options' : '.card-product'

          const priceSrc = html.querySelector((chooseOption || productBundle) ? '.x-card-price .choose-option-price' : '.x-card-price .product-card-price');
          const priceDes = element.closest(target).querySelector('.x-card-price');
          if (this.currentVariant == null) {
            priceDes.classList.add('hidden');
            return;
          } else {
            priceDes.classList.remove('hidden');
          }

          const priceRange = priceDes.querySelector('.price-range');
          if (priceSrc && priceDes) {
            priceDes.innerHTML = priceSrc.innerHTML;
            if (priceRange) {
              const priceEl = priceDes.querySelector('.price');
              if (priceEl) {
                priceEl.innerHTML += priceRange.outerHTML;
              }
            }
          }
        },
        _renderCardProductLabels(html) {
          const labelDataSrc = html.querySelector('.x-labels-data');
          const labelDataDes = element.closest('.card-product').querySelector('.x-labels-data');

          if (labelDataSrc && labelDataDes) {
            labelDataDes.setAttribute('x-labels-data', labelDataSrc.getAttribute('x-labels-data'));
            this.$nextTick(() => {
              Alpine.store('xBadges') && Alpine.store('xBadges').load(labelDataDes, () => {}, null, true);
            });
          }
        },
        _renderCardProductAvailabilityNotice(html) {
          const noticeSrc = html.getElementById('x-availability-notice');
          const noticeDes = element.closest('.card-product').querySelector('div[id*="x-availability-notice"]');

          if (noticeSrc && noticeDes) {
            noticeDes.innerHTML = noticeSrc.innerHTML;
          }
        },
        _renderCardProductImage(html) {
          const variantImageInfo = html.querySelector('#x-variant-image');
          const variantImageSrc = variantImageInfo?.dataset.imageUrl;
          const variantImageTag = variantImageInfo?.dataset.mediaType || '';
          const cardProduct = element.closest('.card-product');

          if (variantImageSrc && variantImageSrc !== '') {
            // Check if the image already exists in a slider
            let media = cardProduct.querySelector(`[media="${variantImageSrc}"]`);
            if (media) {
              let index = media.getAttribute('index');
              let slide = cardProduct.querySelector('.x-splide');
              if (slide && slide.splide) {
                slide.splide.go(Number(index));
                return;
              } 
            }

            // HOVER MODE FIX: Update the first image container
            const firstContainer = cardProduct.querySelector('div[data-image-index="1"]');
            const previewImg = firstContainer?.querySelector(".preview-img");
            
            if (previewImg && firstContainer) {
              previewImg.removeAttribute("srcset");
              previewImg.setAttribute("src", variantImageSrc);
              
              // CRITICAL: Update the tag so the filter logic recognizes this as a match
              firstContainer.setAttribute('data-media-type', variantImageTag);

              // Remove skeleton loading classes to ensure image is visible
              previewImg.classList.remove('animate-Xpulse', 'skeleton-image');
              firstContainer.classList.remove('animate-Xpulse', 'skeleton-image');
            }
          }
        },
        /* The card holds one metal's photographs at a time. Media is grouped by
           metal and the slide cap slices the first few, so only the first metal
           could ever be rendered — tag filtering alone could never surface a
           white-gold shot that was never in the document. The card carries a
           map of the first N images per metal (data-metal-media, built in
           card-product-mio.liquid); this swaps the slides over to whichever
           metal is selected. */
        /* This swap used to strip srcset and write one hardcoded width=750 into
           a box measured at 171 CSS px — 750w for a 513w need on a 3x phone,
           across every visible card on a filtered collection.

           Measuring the element here and picking a width does not work either:
           the stylesheets are deferred, so at swap time the image still lays
           out at 214px and rounds up to 650. Hand the browser the ladder and
           let it choose when it actually knows the box. The sizes attribute
           Liquid rendered is left in place and does the rest. */
        _srcsetFor(base) {
          const sep = base.indexOf('?') > -1 ? '&' : '?';
          return [350, 450, 550, 650, 750, 900, 1100]
            .map(w => base + sep + 'width=' + w + ' ' + w + 'w')
            .join(', ');
        },
        _applyMetalImages() {
          const card = element.closest('.card-product');
          const root = card && card.querySelector('.x-splide[data-metal-media]');
          if (!root) return;

          let map;
          try { map = JSON.parse(root.dataset.metalMedia); } catch (e) { return; }
          if (!map) return;

          const selected = Array.from(element.querySelectorAll('input:checked'))
            .map(input => this._handleize(input.value));
          /* An active metal filter wins over the card's own checked input.

             After a filtered grid swap the server sends the right artwork, then
             each new card initialises and this ran off its DEFAULT checked
             variant — the product's first available metal, not the one filtered
             for — overwriting correct images with the default. That is the
             "right colour while loading, wrong colour after" report. It shows on
             mobile because desktop renders more slides and the length guard
             below usually stops it first.

             Read from the toolbar, not the URL: the filter param carries a gid,
             not a label, and this map is keyed by handleized value. */
          const metalCell = Array.from(document.querySelectorAll('.mio-ft-cell'))
            .find(cell => /metal/i.test((cell.querySelector('.mio-ft-label') || {}).textContent || ''));
          const metalLabel = metalCell && (metalCell.querySelector('.mio-ft-value') || {}).textContent;
          const filtered = metalLabel ? this._handleize(metalLabel.trim()) : '';
          /* "All" is not a metal, so it falls through to the card's own value. */
          const metal = (Array.isArray(map[filtered]) && map[filtered].length ? filtered : null)
            || selected.find(value => Array.isArray(map[value]) && map[value].length);
          if (!metal) return;

          const list = map[metal];
          /* The 3D slide carries a dimmed copy of the first image as a backdrop,
             so it now answers querySelector('img') too. Counted as a photograph
             it makes slides one longer than the map's list for every metal, and
             the length guard below then refuses every swap. It is swapped
             separately, after the photographs. */
          const slides = Array.from(root.querySelectorAll('.splide__slide'))
            .filter(slide => slide.querySelector('img') && !slide.classList.contains('card-3d-slide'));

          /* Swapping only part of the set would leave two metals on one card.
             A metal with fewer images than the card has slides would need the
             slider rebuilt, and hidden slides measure zero wide and knock the
             track off its grid — so leave the card as rendered instead. */
          if (!slides.length || list.length < slides.length) return;

          slides.forEach((slide, i) => {
            const img = slide.querySelector('img');
            const base = list[i];
            if (!img || !base) return;
            const next = base + (base.indexOf('?') > -1 ? '&' : '?') + 'width=750';
            slide.setAttribute('data-media-type', metal);
            slide.setAttribute('media', base);
            /* Still held back by the deferral: hand it the new URL instead of
               setting src. Setting src here would both load the image early,
               defeating the deferral, and then be overwritten when the restore
               replays the original metal. */
            if (img.hasAttribute('data-mio-defer-idle')) {
              img.setAttribute('data-mio-srcset', this._srcsetFor(base));
              img.setAttribute('data-mio-src', next);
              return;
            }
            if (img.getAttribute('src') === next) return;
            img.setAttribute('srcset', this._srcsetFor(base));
            img.setAttribute('src', next);
            img.classList.remove('animate-Xpulse', 'skeleton-image');
          });

          /* Same candidates as the photograph in front of it, so the backdrop
             resolves to a URL the card has already fetched instead of being a
             second download at a width too small for the box. */
          const backdrop = root.querySelector('.card-3d-slide__image');
          if (backdrop && list[0]) {
            const src = list[0] + (list[0].indexOf('?') > -1 ? '&' : '?') + 'width=750';
            if (backdrop.getAttribute('src') !== src) {
              backdrop.setAttribute('srcset', this._srcsetFor(list[0]));
              backdrop.setAttribute('src', src);
            }
          }
        },
        _filterCardImagesByAltTag() {
          const cardProduct = element.closest('.card-product');
          const slideshowContainer = cardProduct?.querySelector('[id^="x-slideshow-card-product-"]');
          if (!slideshowContainer) return;

          const selectedInputs = element.querySelectorAll('input:checked');
          const optionConnects = Array.from(selectedInputs).map(input => this._handleize(input.value));
          const isSliderMode = slideshowContainer.classList.contains('x-splide');

          // Helper to strip Shopify CDN noise (?v=..., _100x100, etc) for clean comparison
          const getCleanUrl = (url) => {
            if (!url) return "";
            return url.split('?')[0].split('&')[0].replace(/(_\d+x\d+)|(_small)|(_medium)|(_large)/g, "");
          };

          if (isSliderMode) {
            const allSlides = slideshowContainer.querySelectorAll('div[data-media-type]');
            const matched = [];
            allSlides.forEach(slide => {
              const data = slide.getAttribute('data-media-type') || '';
              const dataSet = new Set(data.split('_').filter(Boolean));
              if (optionConnects.length === 0 || data === '' || optionConnects.some(opt => dataSet.has(opt))) {
                matched.push(slide);
              }
            });
            /* A card must never be left without a photograph. Where the alt-text
               tags and the option handles disagree — media tagged "gold" against
               an option handleized to "white-gold", say — this hid every image
               slide, leaving the 3D panel as the entire card. It also collapsed
               the hidden slides to zero width, so the slider's own geometry went
               with them and the track parked between slides. Nothing matching is
               treated as no filter at all. */
            const keep = matched.length ? new Set(matched) : null;
            allSlides.forEach(slide => {
              slide.style.display = (!keep || keep.has(slide)) ? '' : 'none';
            });
            if (slideshowContainer.splide) { slideshowContainer.splide.refresh(); slideshowContainer.splide.go(0); }
          } else {
            const allImageDivs = Array.from(slideshowContainer.querySelectorAll('div[data-media-type]'));
            
            // 1. Identify the Main Image Container (Index 1) and its clean URL
            const mainContainer = allImageDivs.find(c => c.getAttribute('data-image-index') === "1");
            const mainImgElement = mainContainer?.querySelector('img');
            // Check both src and data-src/srcset for the most accurate URL
            const mainImageUrl = getCleanUrl(mainImgElement?.getAttribute('src'));

            // 2. Find matching images that are physically different from the main one
            const taggedMatches = allImageDivs.filter(container => {
              const data = container.getAttribute('data-media-type') || '';
              const imgUrl = getCleanUrl(container.querySelector('img')?.getAttribute('src'));
              
              // Exclude if it's the main container OR the same image file
              if (container === mainContainer || imgUrl === mainImageUrl) return false;
              
              const dataSet = new Set(data.split('_').filter(Boolean));
              return optionConnects.some(opt => dataSet.has(opt));
            });

            // 3. Find untagged fallbacks that are physically different
            const untaggedImages = allImageDivs.filter(container => {
              const imgUrl = getCleanUrl(container.querySelector('img')?.getAttribute('src'));
              return container.getAttribute('data-media-type') === '' && 
                     container !== mainContainer && 
                     imgUrl !== mainImageUrl;
            });

            // 4. SELECT HOVER IMAGE: Priority match -> Fallback untagged -> Any different index
            let hoverImage = taggedMatches[0] || untaggedImages[0] || allImageDivs.find(c => getCleanUrl(c.querySelector('img')?.getAttribute('src')) !== mainImageUrl);

            // 5. Apply visibility
            allImageDivs.forEach(container => {
              const isVisible = (container === mainContainer || container === hoverImage);
              container.style.display = isVisible ? '' : 'none';
              
              if (isVisible) {
                const img = container.querySelector('img');
                if (img) {
                  img.classList.remove('animate-Xpulse', 'skeleton-image');
                  // Ensure hidden images are set to block when they become the hover target
                  container.classList.remove('hidden');
                }
              }
            });
          }
        },
        _handleize(text) {
          if (!text) return '';
          return text
            .toString()
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '');
        },
        _renderLinkedProductInput() {
          const desInput = element.closest('.x-product-data-container')?.querySelector('input[name="properties[_linked_product_id][]"]')

          if (desInput) {
            if (this.currentVariant?.available) {
              desInput.value = this.currentVariant.id;
              desInput.disabled = false;
            } else {
              desInput.value = "";
              desInput.disabled = true;
            }
          }
        },
        _renderCurrentOptionText(html) {
          const desSelectedValueText = element.closest('.x-product-data-container')?.querySelectorAll('.option-selected-value');
          const srcSelectedValueText = html.querySelectorAll('.option-selected-value');

          desSelectedValueText?.forEach(des => {
            const src = Array.from(srcSelectedValueText).find((srcText) => srcText.dataset.optionName == des.dataset.optionName);
            if (src && des) {
              des.classList.remove('hidden');
              des.innerHTML = src.innerHTML;
            }
          });
        },
        _renderCustomizableOptionSelectedVariant() {
          const desSelectedVariantText = element.closest('fieldset:has(.x-product-data-container)').querySelector('.selected-variant-name');
          if (desSelectedVariantText) {
            desSelectedVariantText.textContent = `: ${this.currentVariant.name}`;
          }
        },
        _renderCustomizableOptionPriceText(html) {
          const desVariantPriceText = element.closest('fieldset:has(.x-product-data-container)').querySelector(`.variant-price-${productId}`);
          const srcVariantPriceText = html.querySelector(`.variant-price-${productId}`);
          if (desVariantPriceText && srcVariantPriceText) {
            desVariantPriceText.innerHTML = `+ ${srcVariantPriceText.innerHTML}`;
          }
        },
        _getCurrentVariant(html) {
          /* Ask for the selected variant instead of taking whichever block is
             first. The card's Liquid reorders option values (primary_list then
             secondary_list), so document order does not track the selection —
             picking White gold could resolve to Rose gold, and Yellow to White.
             variant-select.js already looks it up this way on the product page.

             Falls back to the old positional read so a card rendered by an older
             template, or by a snippet that does not emit the marker, still works. */
          const box = html.querySelector('.x-variants-data-js');
          const el = (box && box.querySelector('script[type="application/json"][data-selected-variant]'))
            || html.querySelector('script[type="application/json"][data-selected-variant]')
            || html.querySelector('.x-variants-data-js script[type="application/json"]');
          try {
            this.currentVariant = JSON.parse(el?.textContent);
          } catch (e) {
            this.currentVariant = {};
          }
        },
        updateProductCard(optionNum, target, isByob) {
          let callback = () => {};

          const targetUrl = target || element.dataset.url;

          if (chooseOption) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCurrentOptionText(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._dispatchUpdateVariant(html);
              });
            }
          } else if (customizableChooseOption) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductOption(html);
                this._renderLinkedProductInput();
                this._renderCurrentOptionText(html);
                this._renderCustomizableOptionSelectedVariant();
                this._renderCustomizableOptionPriceText(html);
                this._dispatchUpdateVariant(html);
              });
            }
          } else {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._renderCardProductLabels(html);
                this._renderCurrentOptionText(html);
                this._renderCardProductAvailabilityNotice(html);
                this._renderCardProductImage(html);
                this._applyMetalImages();
                this._filterCardImagesByAltTag();
                this._dispatchUpdateVariant(html);
                
                if (isByob) {
                  document.dispatchEvent(new CustomEvent('eurus:product-card-update'));
                }
              });
            }
          }

          this._renderProductCard(targetUrl, optionNum, callback);
        },
        _reloadCardProduct() {
          let link = "";
          const selectedOptionValues = this._getSelectedOptionValues()
          let params = `option_values=${selectedOptionValues.join(',')}`;
          if (chooseOption || productBundle) {
            params = `option_values=${selectedOptionValues.join(',')}&page=${pageParam}`;
          }
          link = `${productUrl.split("?")[0]}?section_id=card-product&${params}`;
          if (this.cachedResults[link] && this.cachedResults[link] !== '') {
            this.cachedResults[link] = '';
          }

          if (chooseOption) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCurrentOptionText(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._dispatchUpdateVariant(html);
              });
            }
          } else if (customizableChooseOption) {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductOption(html);
                this._renderLinkedProductInput();
                this._renderCurrentOptionText(html);
                this._renderCustomizableOptionSelectedVariant();
                this._renderCustomizableOptionPriceText(html);
                this._dispatchUpdateVariant(html);
              });
            }
          } else {
            callback = (html) => {
              window.requestAnimationFrame(() => {
                this._getCurrentVariant(html);
                this._renderCardProductForm(html);
                this._renderCardProductOption(html);
                this._renderCardProductPrice(html);
                this._renderCardProductLabels(html);
                this._renderCardProductAvailabilityNotice(html);
                this._renderCardProductImage(html);
                this._applyMetalImages();
                this._filterCardImagesByAltTag();
                this._dispatchUpdateVariant(html);
              });
            }
          }

          this._renderProductCard(productUrl, -1, callback);
        },
        _renderProductCard(url, optionNum, callback) {
          let link = "";
          const selectedOptionValues = this._getSelectedOptionValues();
          if (optionNum !== -1) {
            if (selectedOptionValues.length < Number(optionNum)) {
              window.requestAnimationFrame(() => {
                setTimeout(() => { this.loadingEls = ''; }, 100);
              });
              return
            };
          }
          if (selectedOptionValues.length === 0) return;
          let params = `option_values=${selectedOptionValues.join(',')}`;
          if (chooseOption || productBundle) {
            params = `option_values=${selectedOptionValues.join(',')}&page=${pageParam}`;
          }
          link = `${url.split("?")[0]}?section_id=card-product&${params}`;
          Alpine.store('xHelper').cancelRequest(`eurus:product_card_request:${productId}`);
          if (this.cachedResults[link] && this.cachedResults[link] !== '') {
            const html = this.cachedResults[link];
            window.requestAnimationFrame(() => {
              callback(html);
            });
          } else {
            const controller = new AbortController();
            Alpine.store('xHelper').requestControllers.set(`eurus:product_card_request:${productId}`, controller);
            fetch(link, { signal: controller.signal })
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                window.requestAnimationFrame(() => {
                  callback(html);
                });
                this.cachedResults[link] = html;
              }).catch(err => {
                if (err.name !== 'AbortError') {
                  console.error(err);
                }
              })
          }
        },
        _getSelectedOptionValues() {
          return Array.from(element.querySelectorAll('select option[selected][value], fieldset input:checked')).map(
            (e) => e.dataset.optionValueId
          );
        }
      }))
    });
  });
}
